export const getAutocompleteData = (state, iri) => state?.autocomplete[iri];

export const getCountIriStr = (iri) => `${iri}-count`;
export const autocompleteOptionsListCountSelector = (iri) => (state) =>
    state?.autocomplete[getCountIriStr(iri)];

export const getAutocompleteFetching = (state) => state.autocomplete?.listingFetching;

export const stateOptionsSelector = (iri) => (state) => getAutocompleteData(state, iri) ?? [];

export const searchResultsSelector = (iri) => (state) =>
    state.autocomplete?.searchResults?.[iri]?.results ?? [];
export const searchCountSelector = (iri) => (state) =>
    state.autocomplete?.searchResults?.[iri]?.count ?? 0;
